export enum NftAttributeDisplayType {
  BoostNumber = 'boost_number',
  BoostPercentage = 'boost_percentage',
  Number = 'number',
  Date = 'date',
}
